<template>
    <div class="goods-form">
        <veui-form ref="culeFormMember" :data="formData">
            <veui-field
                name="product"
                label="选择产品"
                class="veui-field-required"
            >
                <div>
                    <goodsCard
                        :discount-txt="
                            curGoodsInfo.discount && +curGoodsInfo.discount < 10
                                ? curGoodsInfo.discount_txt
                                : ''
                        "
                        :origin-price="curGoodsInfo.price"
                        :name="goodsList.name"
                        :show-price="
                            (curGoodsInfo.price * curGoodsInfo.discount) / 10
                        "
                        show-price-prefix="全国统一价"
                    />
                </div>
            </veui-field>
            <veui-field
                name="num" label="购买数量"
                :rules="numRule"
            >
                <veui-number-input
                    v-model="formData.num"
                    ui="m"
                    :max="100"
                    :min="1"
                    placeholder="请输入不超过100个律临会员数"
                    style="width: 300px;"
                />
            </veui-field>
            <veui-field
                name="isAgree"
                label=""
                :rules="[
                    {
                        name: 'required',
                        trigger: 'change',
                        value: true,
                        message: '请阅读并勾选协议',
                    },
                ]"
            >
                <veui-checkbox v-model="formData.isAgree" :false-value="null">
                    我已阅读并同意<span
                        class="goods-form-rule"
                        @click.stop="openRule"
                    >《{{ agreementInfo.name }}》</span>
                </veui-checkbox>
            </veui-field>
        </veui-form>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 启航会员购买
 * @author
 */

import {Form, Field, Checkbox, NumberInput} from 'veui';
import isBoolean from 'lodash/isBoolean';
import 'veui-theme-dls-icons/exclamation-circle';
import 'veui-theme-dls-icons/building';
import 'veui-theme-dls-icons/tag';
import goodsCard from './goodsCard.vue';

const url = {
    buycode: 'law:/themis/law/commodity/vipbuycode'
};
export default {
    name: 'goodsForm',
    props: {
        goodsList: {
            type: Object,
            default: () => {}
        },
        goodsOrder: {
            type: Object,
            default: () => {}
        },
        agreementInfo: {
            type: Object,
            default: () => {}
        },
        goodsInfo: {
            type: Object,
            default: () => {}
        },
        channel: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            numRule: [
                {
                    name: 'required',
                    value: true,
                    message: '请输入线索数量',
                    triggers: 'change'
                }
            ],
            formData: {},
            validators: [
                {
                    fields: ['num'],
                    validate(value) {
                        return new Promise(resolve => {
                            let res;
                            if (value > 100) {
                                res = {
                                    num: '请输入不超过100个律临会员数'
                                };
                            }
                            return resolve(res);
                        });
                    },
                    triggers: ['change']
                }
            ]
        };
    },
    computed: {
        curGoodsInfo() {
            return this.goodsInfo.young_vip || {};
        }
    },
    components: {
        'veui-form': Form,
        'veui-field': Field,
        'veui-checkbox': Checkbox,
        'veui-number-input': NumberInput,
        goodsCard
    },
    methods: {
        sumbitForm() {
            this.$refs.culeFormMember.validate().then(flag => {
                if (isBoolean(flag) && flag) {
                    // 资金池支付
                    if (+this.channel === 1) {
                        this.$emit('handleCapitalPoolOrder');
                        return;
                    }
                    this.postData();
                }
                else {
                    const toast = {
                        content: '请完成必填选项',
                        duration: 3
                    };
                    this.$Message.info(toast);
                    this.$emit('nextStep', false);
                }
            });
        },
        postData() {
            let postParams = {
                num: this.formData.num, // 购买数量
                agreement_ids: this.agreementInfo.id,
                buy_time: '' + Math.round(new Date().getTime() / 1000), // 下单时间
                code_type: 7
            };
            this.$http
                .post(url.buycode, {
                    ...postParams
                })
                .then(resp => {
                    const data = this.$normalizeResponseData(resp);
                    if (data) {
                        const {
                            num,
                            discount_amount,
                            discount,
                            should_pay_amount
                        } = data.product_info;
                        const order = {
                            name: '启航会员',
                            range: '一年卡',
                            numTxt: `${num}个`,
                            discountAmountTxt:
                                discount_amount > 0
                                    ? `-￥${discount_amount / 100}(${
                                        (discount * 1000) / 100
                                    }折优惠)`
                                    : 'hidden',
                            pay_url: data.order_info.order_info_url,
                            pay_amount: should_pay_amount || 0,
                            num: num || 0
                        };
                        this.$emit('setGoodsFn', 'goodsOrder', order);
                        this.$emit('nextStep', true);
                    }
                    else {
                        this.$emit('nextStep', false);
                    }
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.$emit('nextStep', false);
                });
        },
        openRule() {
            window.open(this.agreementInfo.url);
        }
    }
};
</script>

<style scoped lang="less">
.goods-form {
    margin-bottom: -24px;

    /deep/ .veui-field-label {
        width: calc(5em + 6px);
    }

    .veui-field-no-label {
        margin-left: 12px;
    }

    .goods-form-rule {
        color: #0052cc;
    }

    /deep/ .clue-city-radio > .veui-radio-box {
        display: none;
    }

    .form-icon {
        cursor: pointer;
        color: #282c33;
        margin-left: 12px;
    }
}
</style>
